export enum LocationType {
  MAILING = 'MAILING',
  OTHER = 'OTHER',
  PRIMARY = 'PRIMARY'
}
